"use client";

import { useEffect } from "react";
import { trackLead, trackNewsletterSignup, trackFormInteraction } from "@/lib/analytics/events";

/**
 * Lead Event Tracker Component
 *
 * Exposes the analytics entry points globally so form components can call them
 * without importing. The split matters: trackLeadSubmission is for genuine
 * sales leads and fires Meta/X Lead conversions, while trackNewsletterSignup
 * is audience growth and deliberately does not.
 */
export default function LeadEventTracker() {
  useEffect(() => {
    // Expose the tracking functions globally
    window.trackLead = trackLead;
    window.trackNewsletterSignup = trackNewsletterSignup;
    window.trackFormInteraction = trackFormInteraction;

    return () => {
      // Clean up global references on unmount
      delete window.trackLead;
      delete window.trackNewsletterSignup;
      delete window.trackFormInteraction;
    };
  }, []);

  return null;
}
